export const PROPERTIES_TO_SAVE = [
  `utm_term`,
  `utm_content`
];
